import utils from '@/js/utils';
import MENU_CUSTOMER_INSIGHTS from '@/configs/menus/customer_insights.menu';
export default [{
  path: '/customer_insights/home',
  name: 'InsightsHome',
  component: function component() {
    return import('@/apps/customer-insigths/components/InsightsHome.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('InsightsHome', MENU_CUSTOMER_INSIGHTS)
  }
}, {
  path: '/customer_insights/somos1_home',
  name: 'somos_home',
  component: function component() {
    return import('@/apps/customer-insigths/components/Somos1Home.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('Somos1Home', MENU_CUSTOMER_INSIGHTS)
  }
}, {
  path: '/customer_insights/somos1',
  name: 'somos1_reports_home',
  component: function component() {
    return import('@/apps/customer-insigths/components/Somos1ReportsHome.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('Somos1ReportsHome', MENU_CUSTOMER_INSIGHTS)
  }
}, {
  path: '/customer_insights/visitor_presentation',
  name: 'visitors_presentation',
  component: function component() {
    return import('@/apps/customer-insigths/components/VisitorPresentation.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('VisitorPresentation', MENU_CUSTOMER_INSIGHTS)
  }
}, {
  path: '/customer_insights/somos1/reports',
  name: 'somos1_list',
  component: function component() {
    return import('@/apps/customer-insigths/components/Somos1ReportListPage');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('Somos1List', MENU_CUSTOMER_INSIGHTS)
  }
}, {
  path: '/customer_insights/data_entry',
  name: 'Somos1DataEntry',
  component: function component() {
    return import('@/apps/customer-insigths/components/Somos1DataEntry');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('Somos1DataEntry', MENU_CUSTOMER_INSIGHTS)
  }
}, {
  path: '/customer_insights/somos1/dashboard/:report_id',
  name: 'Somos1',
  component: function component() {
    return import('@/apps/customer-insigths/components/Somos1Report');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('Somos1', MENU_CUSTOMER_INSIGHTS)
  }
}, {
  path: '/customer_insights/tracking_dataentry',
  name: 'TrackingDataEntry',
  component: function component() {
    return import('@/apps/customer-insigths/components/TrackingDataEntry.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('TrackingDataEntry', MENU_CUSTOMER_INSIGHTS)
  }
}, {
  path: '/customer_insights/looker_viewer/dashboard/:report_id',
  name: 'LookerViewer',
  component: function component() {
    return import('@/apps/customer-insigths/components/InsightsLookerViewer.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('LookerViewer', MENU_CUSTOMER_INSIGHTS)
  }
}, {
  path: '/customer_insights/maintenance/somos1',
  name: 'CustomerInsightsMaintenance',
  component: function component() {
    return import('@/apps/customer-insigths/components/CustomerInsightsMaintenancePage');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('Somos1', MENU_CUSTOMER_INSIGHTS)
  }
}, {
  path: '/customer_insights/companies',
  name: 'Companies',
  component: function component() {
    return import('@/apps/customer-insigths/components/CompaniesReportsHome.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('CompaniesReportsHome', MENU_CUSTOMER_INSIGHTS)
  }
}, {
  path: '/customer_insights/companies/reports',
  name: 'companies_list',
  component: function component() {
    return import('@/apps/customer-insigths/components/CompaniesReportListPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('CompaniesList', MENU_CUSTOMER_INSIGHTS)
  }
}, {
  path: '/customer_insights/huascaran/reports',
  name: 'somos1_list',
  component: function component() {
    return import('@/apps/customer-insigths/components/HuascaranReportListPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('HuascaranList', MENU_CUSTOMER_INSIGHTS)
  }
}, {
  path: '/customer_insights/metricas/reports',
  name: 'metricas_list',
  component: function component() {
    return import('@/apps/customer-insigths/components/MetricasReport.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('MetricasList', MENU_CUSTOMER_INSIGHTS)
  }
}, {
  path: '/customer_insights/somos1_v2/regional_indicators_1',
  name: 'somos1_v2_regional_1',
  component: function component() {
    return import('@/apps/customer-insigths/components/somos1V2/page/Somos1V2RegionalIndicators1Page/Somos1V2RegionalIndicators1Page.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('Somos1V2RegionalIndicators1', MENU_CUSTOMER_INSIGHTS)
  }
}, {
  path: '/customer_insights/somos1_v2/regional_indicators_2',
  name: 'somos1_v2_regional_2',
  component: function component() {
    return import('@/apps/customer-insigths/components/somos1V2/page/Somos1V2RegionalIndicators2Page/Somos1V2RegionalIndicators2Page.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('Somos1V2RegionalIndicators2', MENU_CUSTOMER_INSIGHTS)
  }
}, {
  path: '/customer_insights/somos1_v2/configuration',
  name: 'somos1_v2_configuration',
  component: function component() {
    return import('@/apps/customer-insigths/components/somos1V2/page/Somos1V2ConfigurationPage');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('Somos1V2Configuration', MENU_CUSTOMER_INSIGHTS)
  }
}, {
  path: '/customer_insights/dashboards/dictionary',
  name: 'dashboards_dictionary',
  component: function component() {
    return import('@/apps/customer-insigths/components/DashboardDictionary.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('dashboards_dictionary', MENU_CUSTOMER_INSIGHTS)
  }
}];